import { render, staticRenderFns } from "./ImeiComponent.vue?vue&type=template&id=65d590a2&scoped=true&"
import script from "./ImeiComponent.vue?vue&type=script&lang=js&"
export * from "./ImeiComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImeiComponent.vue?vue&type=style&index=0&id=65d590a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d590a2",
  null
  
)

export default component.exports